<template>
    <div>
        <m-assembly-table
            ref="pageForm"
            thDrag
            :formData='formData'
            :columns="columns"
            :data="tableData"
            :tableButtons="tableButtons"
            :loading="loading"
            :settings="settings"
            @onSubmit='onSubmit'
        >
        </m-assembly-table>
    </div>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table';
import { exportExcel2 } from '@/modules/globalprotal/views/financialAccounting/financialAccounting';

export default {
    name: 'wxBomQuery',
    components: {
        mAssemblyTable,
    },
    computed: {
        getFormVal() {
            const formData = this.getFormDataVModel(this.formData.items);
            return {
                vendorCode: this.vendorCode,
                ...formData,
                organizationId: this.orgList.find((item) => item.organizationCode === formData.organizationCode)?.erpOrgId,
            };
        },
    },
    data() {
        return {
            formData: {
                row: 1,
                items: [
                    {
                        value: '',
                        field: 'organizationCode',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('createDeliveryOrderToInformView.t44'), // 库存组织不能为空
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('createDeliveryOrderToInformView.t1'), // 库存组织
                        methods: {
                            change: () => {
                                this.tableData = [];
                            },
                        },
                    },
                    {
                        value: '',
                        field: 'itemCodes',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('wxBom.t1'), // 物料编码不能为空（每次最多只能查找10个物料编码）
                            },
                        },
                        layout: {
                            span: 16,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('createDeliveryOrderToInformView.t16'), // 物料编码
                    },
                ],
            },
            columns: {
                columns: [
                    {
                        title: this.$t('createDeliveryOrderToInformView.t1'), // 库存组织
                        key: 'organizationCode',
                        minWidth: 60,
                        align: 'center',
                    },
                    {
                        title: this.$t('wxBom.t2'), // 外协物料编码
                        key: 'parentPartNumber',
                        minWidth: 110,
                        align: 'center',
                    },
                    {
                        title: this.$t('wxBom.t3'), // 外协物料描述
                        key: 'parentPartDesc',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('gscInvoice.t81'), // 行号
                        key: 'lineNumber',
                        minWidth: 40,
                        align: 'center',
                    },
                    {
                        title: this.$t('wxBom.t4'), // 外协组件编码
                        key: 'partNumber',
                        minWidth: 110,
                        align: 'center',
                    },
                    {
                        title: this.$t('wxBom.t5'), // 组件描述
                        key: 'partDesc',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('gscInvoice.t52'), // 单位
                        key: 'unit',
                        minWidth: 60,
                        align: 'center',
                    },
                    {
                        title: this.$t('wxBom.t6'), // 用量
                        key: 'qty',
                        minWidth: 60,
                        align: 'right',
                    },
                    {
                        title: this.$t('TMRollingForecast.t6'), // 采购员
                        key: 'buyerName',
                        minWidth: 110,
                        align: 'center',
                    },
                    // {
                    //     title: this.$t('wxBom.t7'), // 材料供方简称
                    //     key: 'vendorScale',
                    //     minWidth: 110,
                    //     align: 'center',
                    // },
                    {
                        title: this.$t('wxBom.t8'), // 外协供方自购
                        key: 'isDrDesc',
                        minWidth: 110,
                        align: 'center',
                    },
                ],
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('ApplyReceiveMgnView.exportBtn'), // 导出
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            if (this.$refs.pageForm.validateForm()) {
                                button.loading = true;
                                exportExcel2(`/gscint/wxBom/export?paramJson=${encodeURIComponent(JSON.stringify(this.getFormVal))}`, {}, `${this.$t('route.wxBomQuery')}.xlsx`, this)
                                    .finally(() => {
                                        button.loading = false;
                                    });
                            }
                        },
                    },
                ],
            },
            loading: false,
            settings: {
                needPager: false,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
            },
            INT_WX_MBOM_ORG: [],
        };
    },
    methods: {
        onSubmit() {
            this.search();
        },
        search() {
            this.loading = true;
            axios.post('/gscint/wxBom/query', this.getFormVal)
                .then((res) => {
                    const { code, msg: content, datas } = res.data.data;
                    if (code === '1') {
                        this.tableData = datas;
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async getOrgList() {
            await this.getDictByCode('INT_WX_MBOM_ORG');
            this.getSRMInvLovListNew((data) => {
                this.orgList = data;
                this.getFormDataItemObj(this.formData.items, 'organizationCode').options.values = data.filter((item) => this.INT_WX_MBOM_ORG.some((dict) => dict.code === item.organizationCode)).map((item) => { 
                    return {
                        value: item.organizationCode,
                        label: item.organizationName,
                    };
                });
            });
        },
    },
    mounted() {
        this.getOrgList();
    },
};
</script>
